import { Controller } from "@hotwired/stimulus"

// Opens a <dialog> by id. Use on any button outside the dialog itself.
export default class extends Controller {
  static values = { dialogId: String }

  open() {
    const dialog = document.getElementById(this.dialogIdValue)
    if (dialog && !dialog.open) dialog.showModal()
  }
}
